import * as React from "react";

const IconPaginationArrowLeft: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="currentColor">
            <g fill="none" fillRule="evenodd">
                <g strokeLinejoin="inherit">
                    <circle cx="26" cy="26" r="25" fill="currentColor" stroke="#FFF" strokeWidth="2" />
                    <circle cx="26" cy="26" r="25.5" stroke="currentColor" />
                </g>
                <polygon
                    fill="#FFF"
                    fillRule="nonzero"
                    points="30 26 18 36 18 16"
                    transform="matrix(-1 0 0 1 48 0)"
                />
            </g>
        </svg>
    );
};

export default React.memo(IconPaginationArrowLeft);
